<template>

<svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.2917 22.9583H4.83334C4.1924 22.9583 3.57771 22.7037 3.1245 22.2505C2.67128 21.7973 2.41667 21.1826 2.41667 20.5417V8.45834C2.41667 7.8174 2.67128 7.20271 3.1245 6.7495C3.57771 6.29628 4.1924 6.04167 4.83334 6.04167H10.875" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M15.7083 6.04167H24.1667C24.8076 6.04167 25.4223 6.29628 25.8755 6.7495C26.3287 7.20271 26.5833 7.8174 26.5833 8.45834V20.5417C26.5833 21.1826 26.3287 21.7973 25.8755 22.2505C25.4223 22.7037 24.8076 22.9583 24.1667 22.9583H18.125" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M14.5 18.125C16.502 18.125 18.125 16.502 18.125 14.5C18.125 12.498 16.502 10.875 14.5 10.875C12.498 10.875 10.875 12.498 10.875 14.5C10.875 16.502 12.498 18.125 14.5 18.125Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M21.75 26.5833L18.125 22.9583L21.75 19.3333" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M7.25 2.41667L10.875 6.04167L7.25 9.66667" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

</template>

<script>
export default {
  name: 'IconToogleCam',
  components: {
  },

  data: () => {
    return {
    }
  },

  mounted () {
  },

  methods: {
  }
}
</script>
